import { z } from "zod";
export const UuidSchema = z.string().uuid();
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().optional().default(1),
    limit: z.coerce.number().int().positive().max(100).optional().default(20),
});
export const DateTimeSchema = z.coerce.date();
export const TimestampsSchema = z.object({
    createdAt: DateTimeSchema,
    updatedAt: DateTimeSchema,
});
export const ErrorResponseSchema = z.object({
    code: z.string(),
    message: z.string(),
});
// Matches Fastify sensible's error envelope.
export const HttpErrorSchema = z.object({
    statusCode: z.number(),
    error: z.string(),
    message: z.string(),
});
export const UuidParamsSchema = z.object({
    id: z.string().uuid(),
});
export const MessageResponseSchema = z.object({
    message: z.string(),
});
//# sourceMappingURL=common.js.map